import { axiosConfig } from './axios-config.js'

export const product = {
  // 取得產品分類
  getCategory: (id, token) => axiosConfig.get(`/api/console/product/category/${id}`, token),

  // 創建產品分類
  createCategory: (data, token) => axiosConfig.post('/api/console/product/category', data, token),

  // 更新產品分類
  updateCategory: (id, data, token) => axiosConfig.patch(`/api/console/product/category/${id}`, data, token),

  // 刪除產品分類
  deleteCategory: (id, token) => axiosConfig.delete(`/api/console/product/category/${id}`, token),

  // 取得產品分類Top12
  getCategoryTop: (id, token) => axiosConfig.get(`/api/console/product/category/${id}/top`, token),

  // 更新產品分類Top12
  updateCategoryTop: (id, data, token) => axiosConfig.post(`/api/console/product/category/${id}/top`, data, token),

  // 取得產品
  get: (id, token) => axiosConfig.get(`/api/console/product/${id}`, token),

  // 創建產品
  create: (data, token) => axiosConfig.post('/api/console/product', data, token),

  // 更新產品
  update: (id, data, token) => axiosConfig.patch(`/api/console/product/${id}`, data, token),

  // 更新產品
  delete: (id, token) => axiosConfig.delete(`/api/console/product/${id}`, token)
}
